"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.basesepolia = void 0;
exports.basesepolia = {
    "addresses": {
        "ProxyAdmin": "0xACB32c9d755F2429A6c6Ef681d32E039FcaCa375",
        "Sumer": "0x36E39928204d6DA2b0e19FF6BACdAb94c4837401",
        "CompoundLens": "0x6a7E0B50099375C059fF70F0dDC7Dd5637E3e708",
        "FeedPriceOracle": "0x3E9FBC2D275E4d89C00dd9834236803Abc513129",
        "JumpRate#StableBC": "0xCFfD805AA7B12a1EF1396bA835e1D145cF0f20CE",
        "CompLogic": "0x83d29dbB3CE7cCC91B32d1A570335dBbf5F7A7f0",
        "RedemptionManager": "0x596bf05080cE03ED5bf36ceFfB4943a9820718BA",
        "Timelock": "0xD1114E36E1EFA21a51c85f0c9fBd0F9dd3251D5A",
        "Comptroller": "0x875432296283C6e6E85dfFB6b3F4f16EE1c35913",
        "sdrUSDC": "0x65Acc5c84F69d896930Ef4DBaEEbA102c58A61F5",
        "USDC": "0x036CbD53842c5426634e7929541eC2318f3dCF7e"
    },
    "tokenPairs": [
        {
            "ctokenSym": "sdrUSDC",
            "ctokenAddr": "0x65Acc5c84F69d896930Ef4DBaEEbA102c58A61F5",
            "underlySym": "USDC",
            "ctokenDecimal": 6,
            "underlyDecimal": 6,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0x036CbD53842c5426634e7929541eC2318f3dCF7e",
            "assetGroupId": 1
        }
    ],
    "rateModels": [
        {
            "name": "JumpRate#StableBC",
            "contract": "JumpRateModelV2",
            "address": "0xCFfD805AA7B12a1EF1396bA835e1D145cF0f20CE",
            "tokens": [
                "USDC"
            ],
            "baseRatePerYear": "0",
            "multiplierPerYear": "0.09333",
            "jumpMultiplierPerYear": "3.2",
            "kink": "0.8"
        }
    ],
    "blocksPerYear": 31536000
};
//# sourceMappingURL=basesepolia.js.map